<template>
  <div class="monitor-notify">
    <div role="tablist" class="accordion">
      <b-card>
        <b-card-text>
          Get notified whenever {{ data.name }} has issues or downtime.

          <!--
          <i
            class="fa fa-question-circle"
            aria-hidden="true"
            v-b-tooltip.hover.top
            :title="
              'You\'ll be notified whenever a component ' +
                data.name +
                ' owns has problems. This doesn\'t include third party components.'
            "
          ></i>-->
        </b-card-text>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header
          header-tag="header"
          href="#"
          role="tab"
          v-b-toggle.accordion-1
        >
          <h5 class="mb-0">
            <i class="fas fa-envelope"></i>
            Email
          </h5>
        </b-card-header>
        <b-collapse
          id="accordion-1"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    type="email"
                    placeholder="Email"
                    v-model="email"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="emailSubscribe">
                      Subscribe
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header
          header-tag="header"
          href="#"
          role="tab"
          v-b-toggle.accordion-2
        >
          <h5 class="mb-0">
            <i class="fab fa-slack"></i>
            Slack
          </h5>
        </b-card-header>
        <b-collapse
          id="accordion-2"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <a
                :href="
                  'https://slack.com/oauth/v2/authorize?client_id=786644536177.1208376345524&scope=incoming-webhook&user_scope=&redirect_uri=' +
                  redirectUrl
                "
              >
                <img
                  alt="Add to Slack"
                  height="40"
                  width="139"
                  src="https://platform.slack-edge.com/img/add_to_slack.png"
                  srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
                />
              </a>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!--
      <b-card no-body class="mb-1">
        <b-card-header
          header-tag="header"
          href="#"
          role="tab"
          v-b-toggle.accordion-3
        >
          <h5 class="mb-0">RSS</h5>
        </b-card-header>
        <b-collapse
          id="accordion-3"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              Coming soon!
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      -->
    </div>
  </div>
</template>
<script>
export default {
  name: "monitor-notify",
  // This will either be for notifying an entire WEBSITE (potentially
  // multiple components), or a single individual component.
  props: ["componentInfo", "websiteInfo"],
  data: function () {
    return {
      redirectUrl: `${location.protocol}//${location.host}/handleSlackWebhook`,
      data: {},
      email: ""
    };
  },
  created: function () {
    const currentUrl = `${location.protocol}//${location.host}${location.pathname}`;

    if (this.websiteInfo) {
      this.data = this.websiteInfo;

      localStorage.slack = JSON.stringify({
        redirectUri: currentUrl,
        websiteId: this.websiteInfo.id
      });
    }
  },
  methods: {
    async emailSubscribe() {
      // TODO: Validate email before sending to backend
      const resp = await this.$http.post(
        `/websites/${this.websiteInfo.id}/notifications/email/${this.email}`
      );

      if (!resp.data.success) return;

      this.$emit("close-modal");

      this.$toasted.show("Success! You've subscribed to notifications.", {
        type: "success",
        duration: 5000
      });

      console.log("Email subscribe button clicked!");
      console.log(this.email);
      console.log(resp);
    }
  }
};
</script>
<style>
.monitor-notify i {
  color: #8898aa;
  padding-right: 10px;
  font-size: 16px;
}
</style>
